import { render, staticRenderFns } from "./ReferralFiles.vue?vue&type=template&id=7418caa0&"
import script from "./ReferralFiles.vue?vue&type=script&lang=ts&"
export * from "./ReferralFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports